import { render, staticRenderFns } from "./OptionPropertyPreferencesYN.vue?vue&type=template&id=6d317db8"
import script from "./OptionPropertyPreferencesYN.vue?vue&type=script&lang=js"
export * from "./OptionPropertyPreferencesYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports